import { motion } from "framer-motion";
import { ArrowDown, ShieldCheck, ArrowUpRight } from "lucide-react";

export default function HeroSection({ onNavigate }) {
  return (
    <section data-testid="hero-section" className="border-b border-cream-200 bg-cream-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <p className="eyebrow" data-testid="hero-eyebrow">
            Premium Corporate Supply · Ipoh, Perak
          </p>
          <h1
            data-testid="hero-headline"
            className="mt-4 font-poppins font-semibold text-4xl sm:text-5xl leading-tight text-charcoal-900"
          >
            Sourcing Excellence, Delivered with Distinction
          </h1>
          <p
            data-testid="hero-subcopy"
            className="mt-6 max-w-xl text-base md:text-lg font-light text-charcoal-700 leading-relaxed"
          >
            Az Haniza Enterprise is your trusted partner for corporate
            procurement — from industrial hardware to tailored supply
            solutions, every order is handled with care and professionalism.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-order-button"
              onClick={() => onNavigate("order")}
              className="group flex items-center gap-2 bg-charcoal-900 text-cream-50 text-xs uppercase tracking-[0.2em] font-medium px-7 py-4 rounded-full hover:bg-taupe-700 transition-colors duration-300"
            >
              Place Your Order
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
            <button
              data-testid="hero-showcase-button"
              onClick={() => onNavigate("showcase")}
              className="group flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-medium text-charcoal-900 border border-charcoal-900/20 px-7 py-4 rounded-full hover:border-taupe-600 hover:text-taupe-700 transition-colors duration-300"
            >
              Explore Showcase
              <ArrowDown className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
            </button>
          </div>

          <div className="mt-8 flex items-center gap-3 text-charcoal-500">
            <ShieldCheck className="h-4 w-4 text-taupe-600" />
            <span className="text-xs tracking-wide">
              Every order reviewed personally by our procurement team
            </span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
        >
          <div data-testid="hero-logo-frame" className="space-y-4">
            <div className="rounded-2xl overflow-hidden border border-cream-200 shadow-sm">
              <img
                src="https://images.unsplash.com/photo-1781156771913-899bf3e51b12?w=1200&q=80&auto=format&fit=crop"
                alt="Awning besi moden siap dipasang"
                className="w-full aspect-[16/10] object-cover"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-2xl overflow-hidden border border-cream-200 shadow-sm">
                <img
                  src="https://images.unsplash.com/photo-1786734787245-1e4183f53987?w=800&q=80&auto=format&fit=crop"
                  alt="Grill besi pada tingkap rumah"
                  className="w-full aspect-[4/3] object-cover"
                />
              </div>
              <div className="rounded-2xl overflow-hidden border border-cream-200 shadow-sm">
                <img
                  src="https://images.unsplash.com/photo-1681399559824-c4139f379eb5?w=800&q=80&auto=format&fit=crop"
                  alt="Kerja kimpalan besi di bengkel"
                  className="w-full aspect-[4/3] object-cover"
                />
              </div>
            </div>
          </div>
          <p
            data-testid="hero-badge"
            className="mt-4 text-center text-[11px] uppercase tracking-[0.2em] text-taupe-600"
          >
            Awning · Grill · Kerja Besi — Siap Dipasang
          </p>
        </motion.div>
      </div>
    </section>
  );
}
